import { render } from "./MyFxPreviewCompany.vue?vue&type=template&id=3c7431b4"
import script from "./MyFxPreviewCompany.vue?vue&type=script&lang=js"
export * from "./MyFxPreviewCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__